module.exports = __webpack_public_path__ + "3dd1d56e783908fa146571aee17a07d7.jpg";